// TXT faylni o'qish: avval UTF-8, noto'g'ri belgilar (U+FFFD) chiqsa — windows-1251.
// UTF-16 (BOM bilan, Notepad'ning "Unicode" saqlashi) ham taniladi.

export const MAX_TXT_BYTES = 2 * 1024 * 1024;

export function readFileBytes(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error || new Error("Faylni o'qib bo'lmadi"));
        reader.readAsArrayBuffer(file);
    });
}

// Natija: { text, encoding }
export function decodeTextBytes(buffer) {
    const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    if (bytes[0] === 0xff && bytes[1] === 0xfe) {
        return { text: new TextDecoder('utf-16le').decode(bytes.subarray(2)), encoding: 'utf-16le' };
    }
    if (bytes[0] === 0xfe && bytes[1] === 0xff) {
        return { text: new TextDecoder('utf-16be').decode(bytes.subarray(2)), encoding: 'utf-16be' };
    }
    const utf8 = new TextDecoder('utf-8').decode(bytes);
    if (!utf8.includes('�')) return { text: utf8, encoding: 'utf-8' };
    return { text: new TextDecoder('windows-1251').decode(bytes), encoding: 'windows-1251' };
}

export const isTxtFile = (file) => /\.txt$/i.test(file?.name || '');
